
import '../img/logo_lama_big.png';
import '../img/slogan_big.png';
import '../img/slogan_small.png';

import '../img/ico_glass.png';
import '../img/ico_tools.png';
import '../img/ico_where.png';

import '../img/envelope.svg';
import '../img/geo-alt.svg';
import '../img/telephone.svg';
import '../img/tools.svg';
import '../img/sunglasses.svg';
import '../img/cash.svg';
import '../img/facebook.svg';
import '../img/instagram.svg';
import '../img/twitter.svg';
import '../img/tiktok.svg';



